var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      { attrs: { id: "navBar" } },
      [
        _vm.$route.path == "/events"
          ? [
              _c(
                "div",
                { staticClass: "navItemLeft" },
                [
                  _c("router-link", { attrs: { to: "settings" } }, [
                    _c("img", {
                      staticClass: "colorizePrimaryDark",
                      attrs: {
                        src: require("../assets/images/App_SettingsIcon.png"),
                        height: "24"
                      }
                    })
                  ])
                ],
                1
              )
            ]
          : _vm.$route.path == "/settings"
          ? [
              _c(
                "div",
                { staticClass: "navItemLeft" },
                [
                  _c("router-link", { attrs: { to: "events" } }, [
                    _c("b", [_vm._v("<")]),
                    _vm._v(" Back")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(0)
            ]
          : _vm.$route.path == "/messages"
          ? [
              _c(
                "div",
                { staticClass: "navItemLeft" },
                [
                  _c("router-link", { attrs: { to: "event" } }, [
                    _c("b", [_vm._v("<")]),
                    _vm._v(" Back")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(1)
            ]
          : [
              _c(
                "div",
                { staticClass: "navItemLeft" },
                [
                  _c("router-link", { attrs: { to: "events" } }, [
                    _c("b", [_vm._v("<")]),
                    _vm._v(" Back")
                  ])
                ],
                1
              )
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "navItemMiddle" }, [
      _c("h5", [_vm._v("Settings")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "navItemMiddle" }, [
      _c("h5", [_vm._v("Messages")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81440b78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81440b78","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = null
// module chunks = 